import { useEffect, useState } from "react";
import ListProductPage from "./listProductPage";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AssignmentLogsModal from "./AssignmentLogsModal";

let settigsPage = [
    // { id: 'collection-page', label: 'Collection Page', value: 1 },
    { id: 'product-page', label: 'Product Page', value: 2 },
    { id: 'cart-page', label: 'Cart Page', value: 3 },
    { id: 'cart-drawer-page', label: 'Cart Drawer Page', value: 4 },
    // { id: 'before-checkout-page', label: 'Cart Drawer Page', value: 4 },
    { id: 'checkout-page', label: 'Checkout Page', value: 5 },
    { id: 'post-purchase-page', label: 'Post-Purchase Page', value: 6 },
]

const ProductDesign = ({
    consequentProductData,
    pushedSku,
    setPushedSku,
    selectedTabs,
    setSelectedTabs,
    applyToPage,
    applyToPageForRemove,
    setApplyToPage,
    setApplyToPageForRemove,
    selectedSkuData,
    setSelectedSkuData,
    collectionPageSku,
    setCollectionPageSku,
    productPageSku,
    setProductPageSku,
    cartPageSku,
    setCartPageSku,
    beforeCheckoutPageSku,
    setBeforeCheckoutPageSku,
    CheckoutPageSku,
    setCheckoutPageSku,
    postPurchasePageSku,
    setPostPurchasePageSku,
    setForJsonDataToPush,
    forJsonDataToPush,
    handlePushedToShopifyNew,
    setSkuApiDetails,
    skuApiDetails,
    currentAnalysisData,
    selectedSkuReport,
    order_details_id,
    antecedentProductData,
    setProductList,
    handleView,
    pushedToShopify,
    bulkPushedToShopify,
    bulkRemovedToShopify,
    loadBulkPushedToShopify,
    loadBulkRemovedToShopify,
}) => {

    // const ITEMS_PER_PAGE = 12;
    const [currentPage, setCurrentPage] = useState(1);
    const [isOpen, setIsOpen] = useState(false);

    const [mainTabsActive, setMainTabsActive] = useState("all")
    const [pushedToShopifySkus, setPushedToShopifySkus] = useState([]);
    const [isAllPushed, setIsAllPushed] = useState(false);
    const [view, setView] = useState("list")
    const [filterPage, setFilterPage] = useState("all")
    const [ITEMS_PER_PAGE, SET_ITEMS_PER_PAGE] = useState(10);
    const [searchFilter, setSearchFilter] = useState("");
    const [filteredSku, setFilteredSku] = useState(consequentProductData);
    const [searchSku, setSearchSku] = useState("");
    const [pendingToPushedCount,setPendingToPushedCount] = useState(0);
    const [pushedCount,setPushedCount] = useState(0);
    const [showDescription, setShowDescription] = useState(false);
    

      const infoItems = [
    {
      color: 'blue',
      title: 'Assign Products to Upsell Pages',
      desc: 'Step 1: For every SKU that you see above ☝️ we have shown you the most frequently purchased items along with their count in terms of orders and customers. We call these SKUs "purchased with" items. ',
      icon: <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4" />,
    },
    {
      color: 'green',
      title: 'Push Saved Products Instantly',
      desc: 'Once assignments are made, click “Push to Shopify Store” to publish them immediately.',
      icon: <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />,
    },
    {
      color: 'yellow',
      title: 'Add & Push More Products Anytime',
      desc: 'You can continue assigning new products and push them at any time — no need to repeat previous steps.',
      icon: <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />,
    },
    {
      color: 'purple',
      title: 'Visual Status Indicators',
      desc: (
        <>
          <span className="text-green-600 font-semibold">Green</span> = Pushed to Shopify.{' '}
          <span className="text-red-500 font-semibold">Red</span> = Saved but not pushed.
        </>
      ),
      icon: <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />,
    },
    {
      color: 'red',
      title: 'Remove Mistaken Assignments',
      desc: 'Use “Remove from Page” to undo assignments — only applies to products that haven’t been pushed.',
      icon: <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />,
    },
    {
      color: 'gray',
      title: 'Removing Pushed Products',
      desc: 'To remove pushed products, delete them from Shopify first, then remove them from the assigned upsell location.',
      icon: <path strokeLinecap="round" strokeLinejoin="round" d="M19 13l-7 7-7-7" />,
    },
  ];



    useEffect(() => {
        const lowerQuery = searchFilter.trim().toLowerCase();
        const filtered = Object.entries(consequentProductData)
            .filter(([_, item]) => {
                const title = item.product_title?.toLowerCase() || "";
                const sku = item.sku?.toLowerCase() || "";
                return sku.toLowerCase() === (lowerQuery) || title.includes(lowerQuery);
            })
            .reduce((acc, [key, value]) => {
                acc[key] = value;
                return acc;
            }, {});
        setFilteredSku(filtered)
    }, [searchFilter, consequentProductData])

    const navigate = useNavigate();



    const handleApplyData = () => {
        if (applyToPage == 1) {
            // setCollectionPageSku((prev) => {
            //     const newData = Array.isArray(selectedSkuData) ? selectedSkuData : [selectedSkuData];
            //     // Filter out items that already exist
            //     const filtered = newData.filter(
            //         (item) => !prev.some((existing) => existing.sku === item.sku)
            //     );
            //     setForJsonDataToPush([...prev, ...filtered])
            //     return [...prev, ...filtered];
            // });
        } else if (applyToPage == 2) {
            setProductPageSku((prev) => {
                const newData = Array.isArray(selectedSkuData) ? selectedSkuData : [selectedSkuData];
                // Filter out items that already exist
                const filtered = newData.filter(
                    (item) => !prev.some((existing) => existing.sku === item.sku)
                );
                setForJsonDataToPush([...prev, ...filtered])
                // setForJsonDataToPush(filtered)


                // console.log([...prev, ...filtered],"new changes",newData,prev,filtered)
                return [...prev, ...filtered];
            });
        } else if (applyToPage == 3) {
            setCartPageSku((prev) => {
                const newData = Array.isArray(selectedSkuData) ? selectedSkuData : [selectedSkuData];
                // Filter out items that already exist
                const filtered = newData.filter(
                    (item) => !prev.some((existing) => existing.sku === item.sku)
                );
                setForJsonDataToPush([...prev, ...filtered])
                return [...prev, ...filtered];
            });
        } else if (applyToPage == 4) {
            setBeforeCheckoutPageSku((prev) => {
                const newData = Array.isArray(selectedSkuData) ? selectedSkuData : [selectedSkuData];
                // Filter out items that already exist
                const filtered = newData.filter(
                    (item) => !prev.some((existing) => existing.sku === item.sku)
                );
                setForJsonDataToPush([...prev, ...filtered])
                return [...prev, ...filtered];
            });
        }
        else if (applyToPage == 5) {
            setCheckoutPageSku((prev) => {
                const newData = Array.isArray(selectedSkuData) ? selectedSkuData : [selectedSkuData];
                // Filter out items that already exist
                const filtered = newData.filter(
                    (item) => !prev.some((existing) => existing.sku === item.sku)
                );
                setForJsonDataToPush([...prev, ...filtered])
                return [...prev, ...filtered];
            });
        }
        else if (applyToPage == 6) {
            setPostPurchasePageSku((prev) => {
                const newData = Array.isArray(selectedSkuData) ? selectedSkuData : [selectedSkuData];
                // Filter out items that already exist
                const filtered = newData.filter(
                    (item) => !prev.some((existing) => existing.sku === item.sku)
                );
                setForJsonDataToPush([...prev, ...filtered])
                return [...prev, ...filtered];
            });
        }
        else if (applyToPage == 7) {
            setPostPurchasePageSku((prev) => {
                const newData = Array.isArray(selectedSkuData) ? selectedSkuData : [selectedSkuData];
                // Filter out items that already exist
                const filtered = newData.filter(
                    (item) => !prev.some((existing) => existing.sku === item.sku)
                );
                return [...prev, ...filtered];
            });
            // setCollectionPageSku((prev) => {
            //     const newData = Array.isArray(selectedSkuData) ? selectedSkuData : [selectedSkuData];
            //     // Filter out items that already exist
            //     const filtered = newData.filter(
            //         (item) => !prev.some((existing) => existing.sku === item.sku)
            //     );
            //     return [...prev, ...filtered];
            // });
            setProductPageSku((prev) => {
                const newData = Array.isArray(selectedSkuData) ? selectedSkuData : [selectedSkuData];
                // Filter out items that already exist
                const filtered = newData.filter(
                    (item) => !prev.some((existing) => existing.sku === item.sku)
                );
                return [...prev, ...filtered];
            });
            setCartPageSku((prev) => {
                const newData = Array.isArray(selectedSkuData) ? selectedSkuData : [selectedSkuData];
                // Filter out items that already exist
                const filtered = newData.filter(
                    (item) => !prev.some((existing) => existing.sku === item.sku)
                );
                return [...prev, ...filtered];
            });
            setBeforeCheckoutPageSku((prev) => {
                const newData = Array.isArray(selectedSkuData) ? selectedSkuData : [selectedSkuData];
                // Filter out items that already exist
                const filtered = newData.filter(
                    (item) => !prev.some((existing) => existing.sku === item.sku)
                );
                return [...prev, ...filtered];
            });
            setCheckoutPageSku((prev) => {
                const newData = Array.isArray(selectedSkuData) ? selectedSkuData : [selectedSkuData];
                // Filter out items that already exist
                const filtered = newData.filter(
                    (item) => !prev.some((existing) => existing.sku === item.sku)
                );
                return [...prev, ...filtered];
            });
            setForJsonDataToPush(selectedSkuData)
        }
    }



    const handleRemoveSkuData = () => {
        let isUpdate = false;
        if (applyToPageForRemove == 1) {
            // let selectedSkuValues = selectedSkuData.map((item) => item.sku);
            // selectedSkuValues = selectedSkuValues.filter((sku) => {
            //     return !pushedToShopifySkus.collection_page.includes(sku)
            // })

            // let selectedSkuValues2 = collectionPageSku.map((item) => item.sku);
            // selectedSkuValues = selectedSkuValues.filter((sku) => {
            //     return selectedSkuValues2.includes(sku)
            // })


            // if (selectedSkuValues.length > 0) {
            //     isUpdate = true
            //     setCollectionPageSku((prevSkus) => {
            //         const updated = prevSkus.filter(
            //             (item) => !selectedSkuValues.includes(item.sku)
            //         );
            //         return updated;
            //     });
            // } else {
            //     toast.error(`Selected SkuS: ${pushedSku.join(',')} can't be removed`)
            // }

            // let selectedSkuDataFilter = selectedSkuData.filter((item) => selectedSkuValues.includes(item.sku))
            // if (isUpdate) {
            //     setForJsonDataToPush(selectedSkuDataFilter)
            // }

        } else if (applyToPageForRemove == 2) {

            let selectedSkuValues = selectedSkuData.map((item) => item.sku);
            selectedSkuValues = selectedSkuValues.filter((sku) => {
                return !pushedToShopifySkus.product_page.includes(sku)
            })

            let selectedSkuValues2 = productPageSku.map((item) => item.sku);
            selectedSkuValues = selectedSkuValues.filter((sku) => {
                return selectedSkuValues2.includes(sku)
            })

            if (selectedSkuValues.length > 0) {
                isUpdate = true
                setProductPageSku((prevSkus) => {
                    const selectedSkuValues = selectedSkuData.map((item) => item.sku);

                    const updated = prevSkus.filter(
                        (item) => !selectedSkuValues.includes(item.sku)
                    );
                    return updated;
                });
            } else {
                // toast.error(`Selected SkuS: ${pushedSku.join(',')} can't be removed`)
                toast.error(`The selected SKU (${pushedSku.join(',')}) can’t be removed because it isn’t assigned.`)

            }

            let selectedSkuDataFilter = selectedSkuData.filter((item) => selectedSkuValues.includes(item.sku))
            if (isUpdate) {
                setForJsonDataToPush(selectedSkuDataFilter)
            }


        } else if (applyToPageForRemove == 3) {
            let selectedSkuValues = selectedSkuData.map((item) => item.sku);
            selectedSkuValues = selectedSkuValues.filter((sku) => {
                return !pushedToShopifySkus.cart_page.includes(sku)
            })

            let selectedSkuValues2 = cartPageSku.map((item) => item.sku);
            selectedSkuValues = selectedSkuValues.filter((sku) => {
                return selectedSkuValues2.includes(sku)
            })

            if (selectedSkuValues.length > 0) {
                isUpdate = true
                setCartPageSku((prevSkus) => {
                    const selectedSkuValues = selectedSkuData.map((item) => item.sku);

                    const updated = prevSkus.filter(
                        (item) => !selectedSkuValues.includes(item.sku)
                    );
                    return updated;
                });
            } else {
                // toast.error(`Selected SkuS: ${pushedSku.join(',')} can't be removed`)
                toast.error(`The selected SKU (${pushedSku.join(',')}) can’t be removed because it isn’t assigned.`)

            }

            let selectedSkuDataFilter = selectedSkuData.filter((item) => selectedSkuValues.includes(item.sku))
            if (isUpdate) {
                setForJsonDataToPush(selectedSkuDataFilter)
            }

        } else if (applyToPageForRemove == 4) {
            let selectedSkuValues = selectedSkuData.map((item) => item.sku);
            selectedSkuValues = selectedSkuValues.filter((sku) => {
                return !pushedToShopifySkus.before_checkout_page.includes(sku)
            })

            let selectedSkuValues2 = beforeCheckoutPageSku.map((item) => item.sku);
            selectedSkuValues = selectedSkuValues.filter((sku) => {
                return selectedSkuValues2.includes(sku)
            })

            if (selectedSkuValues.length > 0) {
                isUpdate = true
                setBeforeCheckoutPageSku((prevSkus) => {
                    const selectedSkuValues = selectedSkuData.map((item) => item.sku);

                    const updated = prevSkus.filter(
                        (item) => !selectedSkuValues.includes(item.sku)
                    );
                    return updated;
                });
            } else {
                // toast.error(`Selected SkuS: ${pushedSku.join(',')} can't be removed`)
                toast.error(`The selected SKU (${pushedSku.join(',')}) can’t be removed because it isn’t assigned.`)

            }

            let selectedSkuDataFilter = selectedSkuData.filter((item) => selectedSkuValues.includes(item.sku))
            if (isUpdate) {
                setForJsonDataToPush(selectedSkuDataFilter)
            }

        }
        else if (applyToPageForRemove == 5) {
            let selectedSkuValues = selectedSkuData.map((item) => item.sku);
            selectedSkuValues = selectedSkuValues.filter((sku) => {
                return !pushedToShopifySkus.checkout_page.includes(sku)
            })

            let selectedSkuValues2 = CheckoutPageSku.map((item) => item.sku);
            selectedSkuValues = selectedSkuValues.filter((sku) => {
                return selectedSkuValues2.includes(sku)
            })

            if (selectedSkuValues.length > 0) {
                isUpdate = true
                setCheckoutPageSku((prevSkus) => {
                    const selectedSkuValues = selectedSkuData.map((item) => item.sku);

                    const updated = prevSkus.filter(
                        (item) => !selectedSkuValues.includes(item.sku)
                    );
                    return updated;
                });
            } else {
                // toast.error(`Selected SkuS: ${pushedSku.join(',')} can't be removed`)
                toast.error(`The selected SKU (${pushedSku.join(',')}) can’t be removed because it isn’t assigned.`)

            }

            let selectedSkuDataFilter = selectedSkuData.filter((item) => selectedSkuValues.includes(item.sku))
            if (isUpdate) {
                setForJsonDataToPush(selectedSkuDataFilter)
            }

        }
        else if (applyToPageForRemove == 6) {
            let selectedSkuValues = selectedSkuData.map((item) => item.sku);
            selectedSkuValues = selectedSkuValues.filter((sku) => {
                return !pushedToShopifySkus.post_purchase_page.includes(sku)
            })

            let selectedSkuValues2 = postPurchasePageSku.map((item) => item.sku);
            selectedSkuValues = selectedSkuValues.filter((sku) => {
                return selectedSkuValues2.includes(sku)
            })

            if (selectedSkuValues.length > 0) {
                isUpdate = true
                setPostPurchasePageSku((prevSkus) => {
                    const selectedSkuValues = selectedSkuData.map((item) => item.sku);

                    const updated = prevSkus.filter(
                        (item) => !selectedSkuValues.includes(item.sku)
                    );
                    return updated;
                });
            } else {
                // toast.error(`Selected SkuS: ${pushedSku.join(',')} can't be removed`)
                toast.error(`The selected SKU (${pushedSku.join(',')}) can’t be removed because it isn’t assigned.`)

            }

            let selectedSkuDataFilter = selectedSkuData.filter((item) => selectedSkuValues.includes(item.sku))
            if (isUpdate) {
                setForJsonDataToPush(selectedSkuDataFilter)
            }

        }
        else if (applyToPageForRemove == 7) {
            let selectedSkuValues = selectedSkuData.map((item) => item.sku);
            selectedSkuValues = selectedSkuValues.filter((sku) => {
                return !pushedToShopifySkus.post_purchase_page.includes(sku)
            })

            let selectedSkuValues2 = postPurchasePageSku.map((item) => item.sku);
            selectedSkuValues = selectedSkuValues.filter((sku) => {
                return selectedSkuValues2.includes(sku)
            })

            if (selectedSkuValues.length > 0) {
                setPostPurchasePageSku((prevSkus) => {
                    const selectedSkuValues = selectedSkuData.map((item) => item.sku);

                    const updated = prevSkus.filter(
                        (item) => !selectedSkuValues.includes(item.sku)
                    );
                    return updated;
                });
            }

            // for checkout page
            let selectedSkuValues5 = selectedSkuData.map((item) => item.sku);
            selectedSkuValues5 = selectedSkuValues5.filter((sku) => {
                return !pushedToShopifySkus.checkout_page.includes(sku)
            })

            let selectedSkuValues25 = CheckoutPageSku.map((item) => item.sku);
            selectedSkuValues5 = selectedSkuValues5.filter((sku) => {
                return selectedSkuValues25.includes(sku)
            })

            if (selectedSkuValues5.length > 0) {
                setCheckoutPageSku((prevSkus) => {
                    const selectedSkuValues5 = selectedSkuData.map((item) => item.sku);

                    const updated = prevSkus.filter(
                        (item) => !selectedSkuValues5.includes(item.sku)
                    );
                    return updated;
                });
            }

            // for Cart Drawer Page
            let selectedSkuValues4 = selectedSkuData.map((item) => item.sku);
            selectedSkuValues4 = selectedSkuValues4.filter((sku) => {
                return !pushedToShopifySkus.before_checkout_page.includes(sku)
            })

            let selectedSkuValues24 = beforeCheckoutPageSku.map((item) => item.sku);
            selectedSkuValues4 = selectedSkuValues4.filter((sku) => {
                return selectedSkuValues24.includes(sku)
            })

            if (selectedSkuValues4.length > 0) {
                setBeforeCheckoutPageSku((prevSkus) => {
                    const selectedSkuValues4 = selectedSkuData.map((item) => item.sku);

                    const updated = prevSkus.filter(
                        (item) => !selectedSkuValues4.includes(item.sku)
                    );
                    return updated;
                });
            }
            // for cart poage
            let selectedSkuValues3 = selectedSkuData.map((item) => item.sku);
            selectedSkuValues3 = selectedSkuValues3.filter((sku) => {
                return !pushedToShopifySkus.cart_page.includes(sku)
            })

            let selectedSkuValues23 = cartPageSku.map((item) => item.sku);
            selectedSkuValues3 = selectedSkuValues3.filter((sku) => {
                return selectedSkuValues23.includes(sku)
            })

            if (selectedSkuValues3.length > 0) {
                isUpdate = true
                setCartPageSku((prevSkus) => {
                    const selectedSkuValues3 = selectedSkuData.map((item) => item.sku);

                    const updated = prevSkus.filter(
                        (item) => !selectedSkuValues3.includes(item.sku)
                    );
                    return updated;
                });
            }

            // for product page
            let selectedSkuValuesP2 = selectedSkuData.map((item) => item.sku);
            selectedSkuValuesP2 = selectedSkuValuesP2.filter((sku) => {
                return !pushedToShopifySkus.product_page.includes(sku)
            })

            let selectedSkuValues22 = productPageSku.map((item) => item.sku);
            selectedSkuValuesP2 = selectedSkuValuesP2.filter((sku) => {
                return selectedSkuValues22.includes(sku)
            })

            if (selectedSkuValuesP2.length > 0) {
                setProductPageSku((prevSkus) => {
                    const selectedSkuValuesP2 = selectedSkuData.map((item) => item.sku);

                    const updated = prevSkus.filter(
                        (item) => !selectedSkuValuesP2.includes(item.sku)
                    );
                    return updated;
                });
            }

            // for collection page
            let selectedSkuValues1 = selectedSkuData.map((item) => item.sku);
            selectedSkuValues1 = selectedSkuValues1.filter((sku) => {
                return !pushedToShopifySkus.collection_page.includes(sku)
            })

            let selectedSkuValues21 = collectionPageSku.map((item) => item.sku);
            selectedSkuValues1 = selectedSkuValues1.filter((sku) => {
                return selectedSkuValues21.includes(sku)
            })


            if (selectedSkuValues1.length > 0) {
                isUpdate = true
                setCollectionPageSku((prevSkus) => {
                    const updated = prevSkus.filter(
                        (item) => !selectedSkuValues1.includes(item.sku)
                    );
                    return updated;
                });
            }
            setForJsonDataToPush(selectedSkuData)
        }
    }



    const handleRemoveSkuDataFromAll = () => {
        setCollectionPageSku((prevSkus) => {
            const selectedSkuValues = selectedSkuData.map((item) => item.sku);
            const updated = prevSkus.filter(
                (item) => !selectedSkuValues.includes(item.sku)
            );
            return updated;
        });
        setProductPageSku((prevSkus) => {
            const selectedSkuValues = selectedSkuData.map((item) => item.sku);

            const updated = prevSkus.filter(
                (item) => !selectedSkuValues.includes(item.sku)
            );
            return updated;
        });
        setCartPageSku((prevSkus) => {
            const selectedSkuValues = selectedSkuData.map((item) => item.sku);

            const updated = prevSkus.filter(
                (item) => !selectedSkuValues.includes(item.sku)
            );
            return updated;
        });
        setBeforeCheckoutPageSku((prevSkus) => {
            const selectedSkuValues = selectedSkuData.map((item) => item.sku);

            const updated = prevSkus.filter(
                (item) => !selectedSkuValues.includes(item.sku)
            );
            return updated;
        });
        setCheckoutPageSku((prevSkus) => {
            const selectedSkuValues = selectedSkuData.map((item) => item.sku);

            const updated = prevSkus.filter(
                (item) => !selectedSkuValues.includes(item.sku)
            );
            return updated;
        });
        setPostPurchasePageSku((prevSkus) => {
            const selectedSkuValues = selectedSkuData.map((item) => item.sku);

            const updated = prevSkus.filter(
                (item) => !selectedSkuValues.includes(item.sku)
            );
            return updated;
        });
        setForJsonDataToPush(selectedSkuData)
    }



    const getSavedSkuListData = async () => {
        try {

            const response = await axios.get(
                `${process.env.REACT_APP_API_END_POINT}/ecommerce/list-saved-sku-list-data?analysis_details_id=${currentAnalysisData._id}&order_details_id=${order_details_id}&sku_reports_id=${selectedSkuReport._id}&mainSku=${antecedentProductData.sku}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            let shopfiSkuushed = {
                collection_page: [],
                product_page: [],
                cart_page: [],
                checkout_page: [],
                before_checkout_page: [],
                post_purchase_page: []
            }

            response.data.data.map((item) => {
                if (item.pushedSettings == 1) {
                    setCollectionPageSku(item.pushedSkuDetails)
                    shopfiSkuushed.collection_page = item?.pushedToShopifySku || []
                } else if (item.pushedSettings == 2) {
                    setProductPageSku(item.pushedSkuDetails)
                    shopfiSkuushed.product_page = item?.pushedToShopifySku || []
                } else if (item.pushedSettings == 3) {
                    setCartPageSku(item.pushedSkuDetails)
                    shopfiSkuushed.cart_page = item?.pushedToShopifySku || []
                } else if (item.pushedSettings == 4) {
                    setBeforeCheckoutPageSku(item.pushedSkuDetails)
                    shopfiSkuushed.before_checkout_page = item?.pushedToShopifySku || []
                }
                else if (item.pushedSettings == 5) {
                    setCheckoutPageSku(item.pushedSkuDetails)
                    shopfiSkuushed.checkout_page = item?.pushedToShopifySku || []
                }
                else if (item.pushedSettings == 6) {
                    setPostPurchasePageSku(item.pushedSkuDetails)
                    shopfiSkuushed.post_purchase_page = item?.pushedToShopifySku || []
                }
            })

            if (response.data.data.length == 0) {
                setCollectionPageSku([])
                setProductPageSku([])
                setCartPageSku([])
                setBeforeCheckoutPageSku([])
                setCheckoutPageSku([])
                setPostPurchasePageSku([])
            }

        } catch (error) {
            if (error.response.data?.detail?.isExpireToken) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                navigate("/login")
            }
            toast.error(error.response?.data?.message || error.message);
        }
    }


    const getSkuListDataV2 = async () => {
        // try {

            const response = await axios.get(
                `${process.env.REACT_APP_API_END_POINT}/ecommerce/list-sku-data-v2?analysis_details_id=${currentAnalysisData._id}&order_details_id=${order_details_id}&sku_reports_id=${selectedSkuReport._id}&mainSku=${antecedentProductData.sku}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            let shopfiSkuushed = {
                collection_page: [],
                product_page: [],
                cart_page: [],
                checkout_page: [],
                before_checkout_page: [],
                post_purchase_page: []
            }
            let isPushedAll = true;

            let totalSavedSku = []
            let totalPushedSku = []

            response.data.data.map((item) => {
                if (isPushedAll) {
                    isPushedAll = item.pushedSkuDetails.every((skuItem) =>
                        item?.pushedToShopifySku?.includes(skuItem.sku)
                    );
                }

                let remainingSavedSku = item.pushedSku.filter(sku => !item?.pushedToShopifySku?.includes(sku));
                // console.log(item.pushedSku,item?.pushedToShopifySku,remainingSavedSku,"remainingSavedSku-1",item.pushedSettings)
                let remainingSavedSku1 = remainingSavedSku.filter(sku => !totalSavedSku?.includes(sku))
                // console.log(remainingSavedSku,totalSavedSku,remainingSavedSku1,"remainingSavedSku-2",item.pushedSettings)

                totalSavedSku = [...totalSavedSku, ...(remainingSavedSku1 || [])];
                // console.log(totalSavedSku,remainingSavedSku1,"remainingSavedSku-3",item.pushedSettings)
                let totalPushedSku1 = item?.pushedToShopifySku?.filter(sku => !totalPushedSku?.includes(sku));
                // console.log(totalPushedSku1,item?.pushedToShopifySku,"remainingSavedSku-3",totalPushedSku,item.pushedSettings)
                totalPushedSku = [...totalPushedSku, ...(totalPushedSku1 || [])];
                // console.log(totalPushedSku,"remainingSavedSku-4",item.pushedSettings)



                

                if (item.pushedSettings == 1) {
                    setCollectionPageSku(item.pushedSkuDetails)
                    shopfiSkuushed.collection_page = item?.pushedToShopifySku || []
                } else if (item.pushedSettings == 2) {
                    setProductPageSku(item.pushedSkuDetails)
                    shopfiSkuushed.product_page = item?.pushedToShopifySku || []
                } else if (item.pushedSettings == 3) {
                    setCartPageSku(item.pushedSkuDetails)
                    shopfiSkuushed.cart_page = item?.pushedToShopifySku || []
                } else if (item.pushedSettings == 4) {
                    setBeforeCheckoutPageSku(item.pushedSkuDetails)
                    shopfiSkuushed.before_checkout_page = item?.pushedToShopifySku || []
                }
                else if (item.pushedSettings == 5) {
                    setCheckoutPageSku(item.pushedSkuDetails)
                    shopfiSkuushed.checkout_page = item?.pushedToShopifySku || []
                }
                else if (item.pushedSettings == 6) {
                    setPostPurchasePageSku(item.pushedSkuDetails)
                    shopfiSkuushed.post_purchase_page = item?.pushedToShopifySku || []
                }
            })

            setPushedCount(totalPushedSku.length)
            setPendingToPushedCount(totalSavedSku.length)


            setPushedToShopifySkus(shopfiSkuushed)
            setIsAllPushed(isPushedAll)
            if (response.data.data.length == 0) {
                setCollectionPageSku([])
                setProductPageSku([])
                setCartPageSku([])
                setBeforeCheckoutPageSku([])
                setCheckoutPageSku([])
                setPostPurchasePageSku([])
            }

        // } catch (error) {
        //     if (error.response?.data?.detail?.isExpireToken) {
        //         localStorage.removeItem("token");
        //         localStorage.removeItem("userInfo");
        //         navigate("/login")
        //     }
        //     toast.error(error.response?.data?.message || error.message);
        // }
    }


    useEffect(() => {
        // getSavedSkuListData()
        if (!loadBulkPushedToShopify || !loadBulkRemovedToShopify) {
            getSkuListDataV2();
        }
    }, [loadBulkPushedToShopify, loadBulkRemovedToShopify, forJsonDataToPush])


    let sortedData = Object.entries(filteredSku)
        .map(([key, value]) => ({ sku: key, ...value }))
        .sort((a, b) => b.totalPurchasedTogether - a.totalPurchasedTogether);
    // console.log(consequentProductData, 'consequentProductData',filteredSku)
    const dataEntries = Object.entries(sortedData);
    const totalPages = Math.ceil(dataEntries.length / ITEMS_PER_PAGE);

    const paginatedData = dataEntries.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    return (
        <div class="min-h-screen">

  <div className="">
      {/* Heading with Toggle */}
      <div className="w-full flex flex-col md:flex-row md:items-center md:justify-between">
        <div className="flex items-center space-x-3">
          <h2 className="text-2xl font-bold text-gray-900 flex items-center space-x-2">
            <svg className="w-5 h-5 text-indigo-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M4 6h16M4 12h16M4 18h16" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>Choose Products to Upsell & Push To Shopify Store</span>
          </h2>

          {/* Toggle Button */}
          <button
            onClick={() => setShowDescription(!showDescription)}
            className="text-sm text-indigo-500 font-medium hover:underline focus:outline-none mt-1"
          >
            {showDescription ? ' - How it works?' : 'How it works?'}
          </button>
        </div>

        <div className="text-sm text-gray-500 mt-3 md:mt-0 flex items-center space-x-4">
            
          <span className="text-green-600 font-medium">Total Pushed: {pushedCount}</span>
          <span className="text-yellow-600 font-medium">Pending to Push: {pendingToPushedCount}</span>
        </div>
      </div>

      {/* Toggleable How it Works Section */}
      {showDescription && (

         <div class="bg-white p-6 rounded-2xl  space-y-6">
    <div class="flex items-start gap-4">
      <div class="bg-indigo-500 text-sm text-white rounded-full h-6 w-6 flex items-center justify-center font-bold">1</div>
      <p class="text-gray-700">
        For every SKU you see below, we show the most frequently purchased items along with their order and customer counts.  
        We call these SKUs <span class="font-semibold">"purchased with"</span> items.
      </p>
    </div>

    <div class="flex items-start gap-4">
      <div class="bg-indigo-500 text-sm text-white rounded-full h-6 w-6 flex items-center justify-center font-bold">2</div>
      <p class="text-gray-700">
        Select from the "purchased with" items as upsells for different store locations:  
        <span class="italic"> collection page, product page, cart page, pre-checkout page, checkout page, post-purchase page.</span>
      </p>
    </div>

    <div class="flex items-start gap-4">
      <div class="bg-indigo-500 text-sm text-white rounded-full h-6 w-6 flex items-center justify-center font-bold">3</div>
      <p class="text-gray-700">
        Once you’ve made your selection, click <span class="font-semibold">"Push to Shopify"</span> to apply the upsells.
      </p>
    </div>

    <div class="flex items-start gap-4">
      <div class="bg-indigo-500 text-sm text-white rounded-full h-6 w-6 flex items-center justify-center font-bold">4</div>
      <p class="text-gray-700">
        Repeat this process for every product/SKU you’d like to set up upsells for.
      </p>
    </div>
  </div>

        
      )}
    </div>

        


            <header class="bg-white shadow-sm">
                <div class="w-full mx-auto py-4 flex flex-col items-start">
                    <div class="bg-white mt-5 search-container w-full">
                        <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">



                            <div class="flex items-center">
                                {
                                    view === "grid" &&

                                    <button
                                    id="selectAllBtn"
                                    className={`px-4 py-2 rounded-md transition flex items-center gap-2 text-sm font-medium
                                ${pushedSku.length === sortedData.length && sortedData.length > 0
                                            ? 'bg-green-100 text-green-700 hover:bg-green-200'
                                            : 'bg-gray-100 text-grey-700 hover:bg-grey-200'}`}
                                    onClick={() => {
                                        let allSkus = sortedData.map((item) => item.sku);
                                        setPushedSku((prevSkus) => {
                                            const allSelected = allSkus.every((sku) => prevSkus.includes(sku));
                                            if (allSelected) {
                                                setSelectedSkuData([]);
                                            } else {
                                                setSelectedSkuData(sortedData);
                                            }
                                            return allSelected ? [] : allSkus;
                                        });
                                    }}
                                >
                                    {
                                        view === "grid" &&
                                        <i
                                        className={`fas ${pushedSku.length === sortedData.length && sortedData.length > 0
                                            ? 'fa-check-double'
                                            : 'fa-circle'
                                            }`}
                                    ></i>
                                    }
                                    {view === "grid" && (pushedSku.length === sortedData.length && sortedData.length > 0 ? 'Deselect All' : 'Select All')}
                                </button>
                                }
                                <span class="text-gray-600 ml-3 mr-2">Show:</span>
                                <select class="border border-gray-300 rounded-lg px-3 py-2 focus:border-blue-500 focus:outline-none"
                                    onChange={(e) => {
                                        SET_ITEMS_PER_PAGE(e.target.value)
                                    }}
                                    value={ITEMS_PER_PAGE}
                                >
                                    <option value={10}>10 records</option>
                                    <option value={20}>20 records</option>
                                    <option value={Object.entries(consequentProductData).length}>All records</option>
                                </select>
                            </div>

                            <div className="flex flex-col md:flex-row flex-wrap items-center gap-4">
                                {/* Search Input with Icon */}
                                <div className="relative w-full md:w-auto">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <i className="fas fa-search text-gray-400"></i>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Search Products / SKUs..."
                                        value={searchFilter}
                                        onChange={(e) => setSearchFilter(e.target.value)}
                                        className="w-full md:w-80 pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                                    />
                                </div>

                                {/* Shopify Action Buttons */}
                                <div className="flex gap-2">
                                    
                                        {(collectionPageSku.length > 0 ||
                                            productPageSku.length > 0 ||
                                            beforeCheckoutPageSku.length > 0 ||
                                            CheckoutPageSku.length > 0 ||
                                            postPurchasePageSku.length > 0 ||
                                            cartPageSku.length > 0) &&
                                            !isAllPushed && (
                                                <div className="relative inline-block group">
                                                    <button
                                                        className="inline-flex items-center gap-2 px-3 py-3 text-xs font-semibold text-white bg-green-600 hover:bg-green-700 rounded-lg shadow-sm transition relative"
                                                        onClick={() =>
                                                            bulkPushedToShopify({ mainSku: antecedentProductData.sku })
                                                        }
                                                        disabled={loadBulkPushedToShopify}
                                                    >
                                                        <i className="fas fa-store"></i>
                                                        {loadBulkPushedToShopify ? "Please wait..." : "Push All To Shopify"}
                                                    </button>
                                                        <span className="absolute left-1/2 transform -translate-x-1/2 -top-10 bg-gray-800 text-white text-xs font-medium px-3 py-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-lg whitespace-nowrap">
                                                            All saved locations for this SKU will be synced to Shopify.
                                                        </span>
                                                </div>

                                            )}
                                    {(collectionPageSku.length > 0 ||
                                        productPageSku.length > 0 ||
                                        beforeCheckoutPageSku.length > 0 ||
                                        CheckoutPageSku.length > 0 ||
                                        postPurchasePageSku.length > 0 ||
                                        cartPageSku.length > 0) && pushedCount > 0  && (
                                            <div className="relative inline-block group">
                                                <button
                                                    className="inline-flex items-center gap-2 px-3 py-3 text-xs font-semibold text-white bg-red-600 hover:bg-red-700 rounded-lg shadow-sm transition"
                                                    onClick={() =>
                                                        bulkRemovedToShopify({ mainSku: antecedentProductData.sku })
                                                    }
                                                    disabled={loadBulkRemovedToShopify}
                                                >
                                                    <i className="fas fa-trash"></i>
                                                    {loadBulkRemovedToShopify ? "Please wait..." : "Remove All From Shopify"}
                                                </button>
                                                <span className="absolute left-1/2 transform -translate-x-1/2 -top-10 bg-gray-800 text-white text-xs font-medium px-3 py-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-lg whitespace-nowrap">
                                                    All saved locations will be  removed from Shopify.
                                                </span>
                                            </div>
                                        )}
                                </div>

                                {/* View Toggle (List/Grid) */}
                                <div className="flex border border-gray-300 rounded-lg overflow-hidden">
                                    <button
                                        className={`px-3 py-2 transition ${view === 'list'
                                            ? 'bg-blue-500 text-white'
                                            : 'bg-gray-100 text-gray-700'
                                            }`}
                                        onClick={() => setView('list')}
                                    >
                                        <i className="fas fa-list"></i>
                                    </button>
                                    <button
                                        className={`px-3 py-2 transition ${view === 'grid'
                                            ? 'bg-blue-500 text-white'
                                            : 'bg-gray-100 text-gray-700'
                                            }`}
                                        onClick={() => setView('grid')}
                                    >
                                        <i className="fas fa-th-large"></i>
                                    </button>
                                </div>

                                {/* Logs Button */}
                                <button
                                    className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-700 transition"
                                    onClick={() => setIsOpen(true)}
                                >
                                    <i className="fas fa-history"></i>
                                    <span>View Logs</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

                {/* <div class="w-full mx-auto py-4 flex flex-col items-start">
                        
                    <div class="flex items-center space-x-4">
                        <div className="flex items-center space-x-2">
                            
                            <button
                                className={`px-3 py-1 rounded-md text-sm ${view === "list"
                                        ? "bg-blue-500 text-white"
                                        : "bg-gray-100 text-gray-700"
                                    }`}
                                onClick={() => setView("list")}
                            >
                                List View
                            </button>
                            <button
                                className={`px-3 py-1 rounded-md text-sm ${view === "grid"
                                        ? "bg-blue-500 text-white"
                                        : "bg-gray-100 text-gray-700"
                                    }`}
                                onClick={() => setView("grid")}
                            >
                                Grid View
                            </button>
                        </div>
                        <button class="flex items-center text-sm text-gray-600 hover:text-blue-600"
                            onClick={() => {
                                setIsOpen(true)
                            }}
                        >
                            <i class="fas fa-history mr-1"></i> View Logs
                        </button>


                    </div>
                </div> */}
                {
                    view === "grid" &&
                    <div>
                        <nav className="-mb-px flex overflow-x-auto custom-scrollbar mb-5">
                            {/* <button
                            className={`${mainTabsActive === "all" ? 'border-b-2 border-blue-500 text-blue-600 font-semibold text-sm flex items-center' : ' border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 text-sm flex items-center'} whitespace-nowrap py-4 px-6`}

                            onClick={() => {
                                setMainTabsActive("all")
                            }}

                        >
                            <span>All Products</span>
                        </button> */}
                            <button
                                className={`${mainTabsActive !== "all" ? 'border-b-2 border-blue-500 text-blue-600 font-semibold text-sm flex items-center' : ' border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 text-sm flex items-center'} whitespace-nowrap py-4 px-6 hidden`}
                                onClick={() => {
                                    setMainTabsActive("push_to_shopify")
                                }}

                            >
                                <span>Push All To Shopify</span>
                            </button>
                        </nav>
                    </div>
                }
            </header>

            <main class="w-full mx-auto  bg-white">
                {
                    mainTabsActive !== "all" &&
                    <div className="mb-4 bg-blue-50 border border-blue-200 rounded-lg p-3 flex items-center justify-between mt-5">
                        <div className="flex space-x-2">

                            {
                                (collectionPageSku.length > 0 || productPageSku.length > 0 || beforeCheckoutPageSku.length > 0 || CheckoutPageSku.length > 0 || postPurchasePageSku.length > 0 || cartPageSku.length > 0) && !isAllPushed &&
                                <button
                                    className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                                    onClick={() => {
                                        bulkPushedToShopify({
                                            mainSku: antecedentProductData.sku
                                        })
                                    }}
                                >
                                    Push To Shopify
                                </button>
                            }
                            {
                                (collectionPageSku.length > 0 || productPageSku.length > 0 || beforeCheckoutPageSku.length > 0 || CheckoutPageSku.length > 0 || postPurchasePageSku.length > 0 || cartPageSku.length > 0) &&
                                <button
                                    className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                                    onClick={() => {
                                        bulkRemovedToShopify({
                                            mainSku: antecedentProductData.sku
                                        })
                                    }}
                                >
                                    Remove From Shopify
                                </button>
                            }


                        </div>
                    </div>
                }


                {
                    mainTabsActive === "push_to_shopify" &&
                    <div className="mb-6 bg-white rounded-lg shadow overflow-hidden">
                        <div className="border-b border-gray-200">
                            <nav className="-mb-px flex overflow-x-auto custom-scrollbar">
                                {/* <button
                                className={`${selectedTabs === "all" ? ' border-b-2 border-blue-500 text-blue-600 font-semibold text-sm flex items-center' : ' border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 text-sm flex items-center'} whitespace-nowrap py-4 px-6`}
                                onClick={() => {
                                    setSelectedTabs("all")
                                }}
                            >
                                <span>All Products</span>
                                <span className="ml-2 bg-blue-100 text-blue-800 text-xs font-medium px-2 py-0.5 rounded-full">{Object.entries(consequentProductData).length}</span>
                            </button> */}
                                <button
                                    className={`${selectedTabs === "collection" ? ' border-b-2 border-blue-500 text-blue-600 font-semibold text-sm flex items-center' : ' border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 text-sm flex items-center'} whitespace-nowrap py-4 px-6`}
                                    onClick={() => {
                                        setSelectedTabs("collection")
                                    }}
                                >
                                    <span>Collection Page</span>
                                    <span className="ml-2 bg-blue-100 text-blue-800 text-xs font-medium px-2 py-0.5 rounded-full">{collectionPageSku.length}</span>
                                </button>
                                <button
                                    className={`${selectedTabs === "product" ? ' border-b-2 border-blue-500 text-blue-600 font-semibold text-sm flex items-center' : ' border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 text-sm flex items-center'} whitespace-nowrap py-4 px-6`}
                                    onClick={() => {
                                        setSelectedTabs("product")
                                    }}
                                >
                                    <span>Product Page</span>
                                    <span className="ml-2 bg-blue-100 text-blue-800 text-xs font-medium px-2 py-0.5 rounded-full">{productPageSku.length}</span>
                                </button>
                                <button
                                    className={`${selectedTabs === "cart" ? ' border-b-2 border-blue-500 text-blue-600 font-semibold text-sm flex items-center' : ' border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 text-sm flex items-center'} whitespace-nowrap py-4 px-6`}
                                    onClick={() => {
                                        setSelectedTabs("cart")
                                    }}
                                >
                                    <span>Cart Page</span>
                                    <span className="ml-2 bg-blue-100 text-blue-800 text-xs font-medium px-2 py-0.5 rounded-full">{cartPageSku.length}</span>
                                </button>
                                <button
                                    className={`${selectedTabs === "before_checkout" ? ' border-b-2 border-blue-500 text-blue-600 font-semibold text-sm flex items-center' : ' border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 text-sm flex items-center'} whitespace-nowrap py-4 px-6`}
                                    onClick={() => {
                                        setSelectedTabs("before_checkout")
                                    }}
                                >
                                    <span>Cart Drawer Page</span>
                                    <span className="ml-2 bg-blue-100 text-blue-800 text-xs font-medium px-2 py-0.5 rounded-full">{beforeCheckoutPageSku.length}</span>
                                </button>
                                <button
                                    className={`${selectedTabs === "checkout" ? ' border-b-2 border-blue-500 text-blue-600 font-semibold text-sm flex items-center' : ' border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 text-sm flex items-center'} whitespace-nowrap py-4 px-6`}
                                    onClick={() => {
                                        setSelectedTabs("checkout")
                                    }}
                                >
                                    <span>Checkout Page</span>
                                    <span className="ml-2 bg-blue-100 text-blue-800 text-xs font-medium px-2 py-0.5 rounded-full">{CheckoutPageSku.length}</span>
                                </button>
                                <button
                                    className={`${selectedTabs === "post_purchase" ? ' border-b-2 border-blue-500 text-blue-600 font-semibold text-sm flex items-center' : ' border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 text-sm flex items-center'} whitespace-nowrap py-4 px-6`}
                                    onClick={() => {
                                        setSelectedTabs("post_purchase")
                                    }}
                                >
                                    <span>Post Purchase Page</span>
                                    <span className="ml-2 bg-blue-100 text-blue-800 text-xs font-medium px-2 py-0.5 rounded-full">{postPurchasePageSku.length}</span>
                                </button>
                            </nav>
                        </div>
                    </div>

                }



                {
                    (mainTabsActive == "all") && pushedSku.length > 0 &&
                    <div className="mb-4 bg-blue-50 border border-blue-200 rounded-lg p-3 flex items-center justify-between ">
                        <div className="text-sm text-blue-800">
                            {pushedSku.length} product(s) selected
                        </div>
                        <div className="flex space-x-2">
                            <select
                                className="border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm"
                                disabled={false} // Set to true to disable
                                onChange={(e) => {
                                    setApplyToPage(e.target.value)
                                }}
                                value={applyToPage}
                            >
                                <option
                                    value={""}
                                >Assign to page</option>
                                {

                                    settigsPage.map((option) => {
                                        return <option
                                            value={option.value}
                                        >{option.label}</option>
                                    })

                                }
                                <option
                                    value={7}
                                >
                                    Assign To All Pages
                                </option>
                            </select>
                            <button
                                className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed mr-5"
                                disabled={applyToPage == "" ? true : false}
                                onClick={() => {
                                    handleApplyData()
                                    setSkuApiDetails({
                                        isApply: true
                                    })
                                }}
                            >
                                Apply
                            </button>
                            <select
                                className="border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm"
                                disabled={false} // Set to true to disable
                                onChange={(e) => {
                                    setApplyToPageForRemove(e.target.value)
                                }}
                                value={applyToPageForRemove}
                            >
                                <option
                                    value={""}
                                >Remove from page</option>
                                {

                                    settigsPage.map((option) => {
                                        return <option
                                            value={option.value}
                                        >{option.label}</option>
                                    })
                                }
                                <option
                                    value={7}
                                >
                                    Remove from All Pages
                                </option>
                            </select>
                            <button
                                className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                                disabled={applyToPageForRemove == "" ? true : false}
                                onClick={() => {
                                    handleRemoveSkuData()
                                    setSkuApiDetails({
                                        isRemove: true
                                    })
                                }}
                            >
                                Remove
                            </button>
                            <button
                                className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                onClick={() => {
                                    handleRemoveSkuDataFromAll()
                                    setSkuApiDetails({
                                        isRemoveAll: true
                                    })
                                }}
                            >
                                Reset
                            </button>
                        </div>
                    </div>
                }



                {
                    view === "grid" &&
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                        {
                            mainTabsActive === "all" &&
                            paginatedData.map(([Key, data]) => {

                                let isActive = pushedSku.some((check) => check == data.sku)
                                return <div
                                    className={`product-card bg-blue-50 border-blue-500 rounded-lg shadow overflow-hidden ${isActive && 'border-2'} cursor-pointer hover:border-blue-500 transition-colors duration-200`}
                                    onClick={() => {
                                        setPushedSku((old) => {
                                            if (old.includes(data.sku)) {
                                                // Remove it
                                                return old.filter((sku) => sku !== data.sku);
                                            } else {
                                                // Add it
                                                return [...old, data.sku];
                                            }
                                        });
                                        setSelectedSkuData((old) => {
                                            const exists = old.some((item) => item.sku === data.sku);

                                            if (exists) {
                                                // Remove object with matching sku
                                                return old.filter((item) => item.sku !== data.sku);
                                            } else {
                                                // Add new object
                                                return [...old, data];
                                            }
                                        });
                                    }}
                                >
                                    <div class="relative product-card bg-blue-50 border-blue-500 rounded-lg shadow overflow-hidden cursor-pointer hover:border-blue-500 transition-colors duration-200">

                                        <input class="absolute top-3 mt-3 left-2 h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 z-10" type="checkbox" checked={isActive} />

                                        <div className="ml-4 p-4">
                                            <div className="flex justify-between items-start">
                                                <div>
                                                    <h3 className="text-lg font-medium text-gray-900 mb-1">{data.product_title}</h3>
                                                    <p className="text-sm text-gray-500 mb-2">{data.sku}</p>
                                                </div>
                                                <img
                                                    src={data.image || "/noimage.jpg"}
                                                    alt="Product"
                                                    className="h-16 w-16 object-cover rounded"
                                                />
                                            </div>
                                            <div className="mt-3 flex justify-between items-center">
                                                <span
                                                    className="text-sm font-medium text-gray-900 underline"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleView(
                                                            data?.antecedentSkus,
                                                            data?.consequentSkus,
                                                            data?.allSkus,
                                                            true
                                                        );
                                                        setProductList(data.allData);
                                                    }}
                                                >
                                                    {data.together_customer_count || 0} Customers
                                                </span>
                                                <span className="px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800 underline"

                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleView(
                                                            data?.antecedentSkus,
                                                            data?.consequentSkus,
                                                            data?.allSkus,
                                                            true
                                                        );
                                                        setProductList(data.allData);
                                                    }}
                                                >
                                                    {data.totalPurchasedTogether || 0} Orders
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div class="border-t border-green-500 bg-green-50 px-4 py-3">
                                        <h4 class="text-sm font-semibold text-green-800 mb-2">Pushed to Shopify</h4>
                                        <div className="flex flex-wrap gap-2">
                                            {(() => {
                                                const pageLabels = [];

                                                if (pushedToShopifySkus.collection_page.includes(data.sku)) {
                                                    pageLabels.push("Collection Page");
                                                }
                                                if (pushedToShopifySkus.product_page.includes(data.sku)) {
                                                    pageLabels.push("Product Page");
                                                }
                                                if (pushedToShopifySkus.cart_page.includes(data.sku)) {
                                                    pageLabels.push("Cart Page");
                                                }
                                                if (pushedToShopifySkus.before_checkout_page.includes(data.sku)) {
                                                    pageLabels.push("Cart Drawer Page");
                                                }
                                                if (pushedToShopifySkus.checkout_page.includes(data.sku)) {
                                                    pageLabels.push("Checkout Page");
                                                }
                                                if (pushedToShopifySkus.post_purchase_page.includes(data.sku)) {
                                                    pageLabels.push("Post Purchase Page");
                                                }

                                                if (pageLabels.length === 0) {
                                                    return <span className="text-xs text-gray-500">Not Pushed Yet</span>;
                                                }

                                                return pageLabels.map((label) => (
                                                    <span
                                                        key={label}
                                                        className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800"
                                                    >
                                                        {label}
                                                    </span>
                                                ));
                                            })()}
                                        </div>
                                    </div> */}


                                    <div className="border-t border-gray-200 px-4 py-3 bg-yellow-50">
                                        <h4 class="text-sm font-semibold text-yellow-800 mb-2">Published Status</h4>
                                        <div className="flex justify-between items-center">
                                            <div className="flex flex-wrap gap-1">
                                            {/* {
                                                collectionPageSku.some((check) => check.sku === data.sku) && (
                                                    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mr-1 ${
                                                    pushedToShopifySkus?.collection_page?.includes(data.sku)
                                                        ? 'bg-green-100 text-green-800'
                                                        : 'bg-red-100 text-red-800'
                                                    }`}>
                                                    Collection Page
                                                    </span>
                                                )
                                            } */}
                                            {
                                            productPageSku.some((check) => check.sku === data.sku) && (
                                                <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mr-1 ${
                                                pushedToShopifySkus?.product_page?.includes(data.sku)
                                                    ? 'bg-green-100 text-green-800'
                                                    : 'bg-red-100 text-red-800'
                                                }`}>
                                                Product Page
                                                </span>
                                            )
                                            }
                                            {
                                            cartPageSku.some((check) => check.sku === data.sku) && (
                                                <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mr-1 ${
                                                pushedToShopifySkus?.cart_page?.includes(data.sku)
                                                    ? 'bg-green-100 text-green-800'
                                                    : 'bg-red-100 text-red-800'
                                                }`}>
                                                Cart Page
                                                </span>
                                            )
                                            }
                                            {
                                            beforeCheckoutPageSku.some((check) => check.sku === data.sku) && (
                                                <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mr-1 ${
                                                pushedToShopifySkus?.before_checkout_page?.includes(data.sku)
                                                    ? 'bg-green-100 text-green-800'
                                                    : 'bg-red-100 text-red-800'
                                                }`}>
                                                Cart Drawer Page
                                                </span>
                                            )
                                            }
                                            {
                                            CheckoutPageSku.some((check) => check.sku === data.sku) && (
                                                <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mr-1 ${
                                                pushedToShopifySkus?.checkout_page?.includes(data.sku)
                                                    ? 'bg-green-100 text-green-800'
                                                    : 'bg-red-100 text-red-800'
                                                }`}>
                                                Checkout Page
                                                </span>
                                            )
                                            }
                                            {
                                            postPurchasePageSku.some((check) => check.sku === data.sku) && (
                                                <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mr-1 ${
                                                pushedToShopifySkus?.post_purchase_page?.includes(data.sku)
                                                    ? 'bg-green-100 text-green-800'
                                                    : 'bg-red-100 text-red-800'
                                                }`}>
                                                Post Purchase Page
                                                </span>
                                            )
                                            }

                                            {
                                            !(
                                                collectionPageSku.some((check) => check.sku === data.sku) ||
                                                productPageSku.some((check) => check.sku === data.sku) ||
                                                cartPageSku.some((check) => check.sku === data.sku) ||
                                                beforeCheckoutPageSku.some((check) => check.sku === data.sku) ||
                                                CheckoutPageSku.some((check) => check.sku === data.sku) ||
                                                postPurchasePageSku.some((check) => check.sku === data.sku)
                                            ) && (
                                                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800 mr-1">
                                                Not Saved Yet
                                                </span>
                                            )
                                            }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                }

                {
                    view === "list" &&
                    <div class=" ">
                        <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
                            {/* <h2 class="text-xl font-semibold text-gray-700 mb-2 md:mb-0">Available Products</h2> */}
                            <div class="flex space-x-2">
                                {/* <button id="selectAllBtn" class="px-4 py-2 bg-blue-100 text-blue-700 rounded-md hover:bg-blue-200 transition"
                                onClick={() => {
                                    let allSkus = sortedData.map((item) => item.sku);
                                    setPushedSku((prevSkus) => {
                                      // If all SKUs are already selected, clear them
                                      const allSelected = allSkus.every((sku) => prevSkus.includes(sku));
                                      if(allSelected){
                                        setSelectedSkuData([])
                                      }else{
                                        setSelectedSkuData(sortedData)
                                      }
                                      return allSelected ? [] : allSkus;
                                    });

                                    
                                  }}
                                >
                                    <i class="fas fa-check-circle mr-2"></i>Select All
                                </button> */}
                                {/* <button id="pushToUpsellBtn" class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition flex items-center">
                                    <i class="fas fa-arrow-up mr-2"></i>Push to Upsell
                                </button> */}
                            </div>
                        </div>

                        <div class="overflow-x-auto">
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead class="bg-gray-50">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            <input type="checkbox" id="masterCheckbox" class="checkbox-round"
                                                onClick={(e) => {
                                                    let allskus = sortedData.map((item) => item.sku)

                                                    if (e.target.checked) {
                                                        setPushedSku(allskus)
                                                        setSelectedSkuData(sortedData)
                                                    } else {
                                                        setPushedSku([])
                                                        setSelectedSkuData([])
                                                    }
                                                }}
                                            />
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product Information</th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Orders & Customers</th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Published Status</th>
                                        {/* <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pushed Location</th> */}

                                    </tr>
                                </thead>
                                <tbody class="bg-white divide-y divide-gray-200" id="productTableBody">
                                    {

                                        paginatedData.map(([Key, data]) => {
                                            let isActive = pushedSku.some((check) => check == data.sku)
                                            return <tr>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <input type="checkbox" checked={isActive} class="product-checkbox checkbox-round"

                                                        onClick={() => {
                                                            setPushedSku((old) => {
                                                                if (old.includes(data.sku)) {
                                                                    // Remove it
                                                                    return old.filter((sku) => sku !== data.sku);
                                                                } else {
                                                                    // Add it
                                                                    return [...old, data.sku];
                                                                }
                                                            });
                                                            setSelectedSkuData((old) => {
                                                                const exists = old.some((item) => item.sku === data.sku);

                                                                if (exists) {
                                                                    // Remove object with matching sku
                                                                    return old.filter((item) => item.sku !== data.sku);
                                                                } else {
                                                                    // Add new object
                                                                    return [...old, data];
                                                                }
                                                            });
                                                        }}
                                                    />
                                                </td>

                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex items-center">
                                                        <img
                                                            src={data.image || "/noimage.jpg"}
                                                            alt="Product"
                                                            className="h-16 w-16 object-cover rounded mr-4"
                                                        />

                                                        <div className="flex flex-col">
                                                            <span className="text-sm font-medium text-gray-900">{data.product_title}</span>
                                                            <span className="text-sm text-gray-500 mt-1">{data.sku}</span>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <span className="px-2 py-1 text-xs font-medium rounded-full  text-gray-900 underline cursor-pointer"

                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleView(
                                                                data?.antecedentSkus,
                                                                data?.consequentSkus,
                                                                data?.allSkus,
                                                                true
                                                            );
                                                            setProductList(data.allData);
                                                        }}
                                                    >
                                                        {data.totalPurchasedTogether || 0} Orders
                                                    </span>

                                                    <span
                                                        className="px-2 py-1 text-xs font-medium rounded-full  text-gray-900 underline cursor-pointer"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleView(
                                                                data?.antecedentSkus,
                                                                data?.consequentSkus,
                                                                data?.allSkus,
                                                                true
                                                            );
                                                            setProductList(data.allData);
                                                        }}
                                                    >
                                                        {data.together_customer_count || 0} Customers
                                                    </span>
                                                </td>


                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {/* {
                                                        collectionPageSku.some((check) => check.sku === data.sku) && (
                                                            <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mr-1 ${pushedToShopifySkus?.collection_page?.includes(data.sku)
                                                                ? 'bg-green-100 text-green-800'
                                                                : 'bg-red-100 text-red-800'
                                                                }`}>
                                                                Collection Page
                                                            </span>
                                                        )
                                                    } */}
                                                    {
                                                        productPageSku.some((check) => check.sku === data.sku) && (
                                                            <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mr-1 ${pushedToShopifySkus?.product_page?.includes(data.sku)
                                                                ? 'bg-green-100 text-green-800'
                                                                : 'bg-red-100 text-red-800'
                                                                }`}>
                                                                Product Page
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                        cartPageSku.some((check) => check.sku === data.sku) && (
                                                            <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mr-1 ${pushedToShopifySkus?.cart_page?.includes(data.sku)
                                                                ? 'bg-green-100 text-green-800'
                                                                : 'bg-red-100 text-red-800'
                                                                }`}>
                                                                Cart Page
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                        beforeCheckoutPageSku.some((check) => check.sku === data.sku) && (
                                                            <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mr-1 ${pushedToShopifySkus?.before_checkout_page?.includes(data.sku)
                                                                ? 'bg-green-100 text-green-800'
                                                                : 'bg-red-100 text-red-800'
                                                                }`}>
                                                                Cart Drawer Page
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                        CheckoutPageSku.some((check) => check.sku === data.sku) && (
                                                            <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mr-1 ${pushedToShopifySkus?.checkout_page?.includes(data.sku)
                                                                ? 'bg-green-100 text-green-800'
                                                                : 'bg-red-100 text-red-800'
                                                                }`}>
                                                                Checkout Page
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                        postPurchasePageSku.some((check) => check.sku === data.sku) && (
                                                            <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mr-1 ${pushedToShopifySkus?.post_purchase_page?.includes(data.sku)
                                                                ? 'bg-green-100 text-green-800'
                                                                : 'bg-red-100 text-red-800'
                                                                }`}>
                                                                Post Purchase Page
                                                            </span>
                                                        )
                                                    }
                                                </td>
                                                {/* <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {
                                                        pushedToShopifySkus?.collection_page?.some((check) => check == data.sku) &&
                                                        <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">Collection Page</span>
                                                    }
                                                    {
                                                        pushedToShopifySkus?.product_page?.some((check) => check == data.sku) &&
                                                        <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">Product Page</span>
                                                    }
                                                    {
                                                        pushedToShopifySkus?.cart_page?.some((check) => check == data.sku) &&
                                                        <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">Cart Page</span>
                                                    }
                                                    {
                                                        pushedToShopifySkus?.before_checkout_page?.some((check) => check == data.sku) &&
                                                        <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">Cart Drawer Page</span>
                                                    }
                                                    {
                                                        pushedToShopifySkus?.checkout_page?.some((check) => check == data.sku) &&
                                                        <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">Checkout Page</span>
                                                    }
                                                    {
                                                        pushedToShopifySkus?.post_purchase_page?.some((check) => check == data.sku) &&
                                                        <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">Post Purchase Page</span>
                                                    }
                                                </td> */}
                                            </tr>
                                        })
                                    }


                                </tbody>
                            </table>
                        </div>
                    </div>


                }






                {
                    selectedTabs === "collection" && mainTabsActive !== "all" &&
                    <ListProductPage
                        collectionPageSku={collectionPageSku}
                        pushedToShopifySkus={pushedToShopifySkus.collection_page}
                        allSku={
                            {
                                collectionPageSku,
                                CheckoutPageSku,
                                cartPageSku,
                                CheckoutPageSku,
                                beforeCheckoutPageSku,
                                productPageSku
                            }
                        }
                    />
                }
                {
                    selectedTabs === "checkout" && mainTabsActive !== "all" &&
                    <ListProductPage
                        collectionPageSku={CheckoutPageSku}
                        pushedToShopifySkus={pushedToShopifySkus.checkout_page}
                        allSku={
                            {
                                collectionPageSku,
                                CheckoutPageSku,
                                cartPageSku,
                                CheckoutPageSku,
                                beforeCheckoutPageSku,
                                productPageSku
                            }
                        }

                    />
                }
                {
                    selectedTabs === "before_checkout" && mainTabsActive !== "all" &&
                    <ListProductPage
                        collectionPageSku={beforeCheckoutPageSku}
                        pushedToShopifySkus={pushedToShopifySkus.before_checkout_page}
                        allSku={
                            {
                                collectionPageSku,
                                CheckoutPageSku,
                                cartPageSku,
                                CheckoutPageSku,
                                beforeCheckoutPageSku,
                                productPageSku
                            }
                        }

                    />
                }
                {
                    selectedTabs === "cart" && mainTabsActive !== "all" &&
                    <ListProductPage
                        collectionPageSku={cartPageSku}
                        pushedToShopifySkus={pushedToShopifySkus.cart_page}
                        allSku={
                            {
                                collectionPageSku,
                                CheckoutPageSku,
                                cartPageSku,
                                CheckoutPageSku,
                                beforeCheckoutPageSku,
                                productPageSku
                            }
                        }

                    />
                }
                {
                    selectedTabs === "product" && mainTabsActive !== "all" &&
                    <ListProductPage
                        collectionPageSku={productPageSku}
                        pushedToShopifySkus={pushedToShopifySkus.product_page}
                        allSku={
                            {
                                collectionPageSku,
                                CheckoutPageSku,
                                cartPageSku,
                                CheckoutPageSku,
                                beforeCheckoutPageSku,
                                productPageSku
                            }
                        }

                    />
                }
                {
                    selectedTabs === "post_purchase" && mainTabsActive !== "all" &&
                    <ListProductPage
                        collectionPageSku={postPurchasePageSku}
                        pushedToShopifySkus={pushedToShopifySkus.post_purchase_page}
                        allSku={
                            {
                                collectionPageSku,
                                CheckoutPageSku,
                                cartPageSku,
                                CheckoutPageSku,
                                beforeCheckoutPageSku,
                                productPageSku
                            }
                        }
                    />
                }

                {mainTabsActive === "all" && totalPages > 1 && (
                    <div className="flex justify-center gap-2 mt-4 flex-wrap">
                        <button
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            className="px-3 py-1 text-sm rounded border bg-white text-gray-700 hover:bg-gray-100 disabled:opacity-40"
                        >
                            Prev
                        </button>

                        {(() => {
                            const maxVisible = 5;
                            let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                            let endPage = startPage + maxVisible - 1;

                            if (endPage > totalPages) {
                                endPage = totalPages;
                                startPage = Math.max(1, endPage - maxVisible + 1);
                            }

                            const pages = [];

                            if (startPage > 1) {
                                pages.push(
                                    <button
                                        key={1}
                                        onClick={() => setCurrentPage(1)}
                                        className={`px-3 py-1 text-sm rounded border ${1 === currentPage ? "bg-blue-600 text-white" : "bg-white text-gray-700 hover:bg-gray-100"}`}
                                    >
                                        1
                                    </button>
                                );
                                if (startPage > 2) {
                                    pages.push(<span key="start-ellipsis" className="px-2">...</span>);
                                }
                            }

                            for (let page = startPage; page <= endPage; page++) {
                                pages.push(
                                    <button
                                        key={page}
                                        onClick={() => setCurrentPage(page)}
                                        className={`px-3 py-1 text-sm rounded border ${page === currentPage ? "bg-blue-600 text-white" : "bg-white text-gray-700 hover:bg-gray-100"}`}
                                    >
                                        {page}
                                    </button>
                                );
                            }

                            if (endPage < totalPages) {
                                if (endPage < totalPages - 1) {
                                    pages.push(<span key="end-ellipsis" className="px-2">...</span>);
                                }
                                pages.push(
                                    <button
                                        key={totalPages}
                                        onClick={() => setCurrentPage(totalPages)}
                                        className={`px-3 py-1 text-sm rounded border ${totalPages === currentPage ? "bg-blue-600 text-white" : "bg-white text-gray-700 hover:bg-gray-100"}`}
                                    >
                                        {totalPages}
                                    </button>
                                );
                            }

                            return pages;
                        })()}

                        <button
                            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                            className="px-3 py-1 text-sm rounded border bg-white text-gray-700 hover:bg-gray-100 disabled:opacity-40"
                        >
                            Next
                        </button>
                    </div>
                )}

                {
                    (view === "list" || view === "grid") &&
                    <div class="mt-40 hidden">

                        <div class="hidden w-full mx-auto py-4 flex flex-col items-start">
                            <h1 class="text-2xl font-bold text-gray-900">
                                <i class="fas fa-store"></i>&nbsp; Push To Shopify Store
                            </h1>
                            <p class="mt-2 text-gray-600">
                                The products listed below are the ones you have saved. You can now push all of them to Shopify at once. Products that are already pushed will be marked as “Pushed to Shopify.” For products not yet pushed, you can push them in one go using the Push to Shopify button.</p>
                            <p className="mt-2">
                                <span className="text-red-500 ">Note:</span> <i>If you want to remove products from Shopify, simply press Remove from Shopify and they will be removed from all locations.</i>
                            </p>
                        </div>

                        <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
                            <div class="flex flex-col md:flex-row md:items-center gap-3 flex-grow">
                                <div class="relative w-full md:w-64">
                                    <input type="text" placeholder="Search sku..." class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={searchSku}
                                        onChange={(e) => {
                                            setSearchSku(e.target.value)
                                        }}
                                    />
                                    <div class="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                                        <i class="fas fa-search text-gray-400"></i>
                                    </div>
                                </div>


                            </div>

                            <div class="flex gap-4 md:ml-auto">

                                <div>
                                    <label for="locationFilter" class="sr-only">Filter by location</label>
                                    <select
                                        id="locationFilter"
                                        className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        onChange={(e) => setFilterPage(e.target.value)}
                                        value={filterPage}
                                    >
                                        <option value="all">View All Locations</option>
                                        {/* <option value="collection">View  Collection Page</option> */}
                                        <option value="product">View Product Page</option>
                                        <option value="cart">View Cart Page</option>
                                        <option value="before_checkout">View Cart Drawer Page</option>
                                        <option value="checkout">View Checkout Page</option>
                                        <option value="post_purchase">View Post Purchase Page</option>
                                    </select>
                                </div>
                                {
                                    (collectionPageSku.length > 0 || productPageSku.length > 0 || beforeCheckoutPageSku.length > 0 || CheckoutPageSku.length > 0 || postPurchasePageSku.length > 0 || cartPageSku.length > 0) && !isAllPushed &&
                                    <button
                                        className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                                        onClick={() => {
                                            bulkPushedToShopify({
                                                mainSku: antecedentProductData.sku
                                            })
                                        }}
                                    >
                                        <i class="fas fa-store"></i>&nbsp;Push All To Shopify
                                    </button>
                                }
                                {
                                    (collectionPageSku.length > 0 || productPageSku.length > 0 || beforeCheckoutPageSku.length > 0 || CheckoutPageSku.length > 0 || postPurchasePageSku.length > 0 || cartPageSku.length > 0) &&
                                    <button
                                        className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-red-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                                        onClick={() => {
                                            bulkRemovedToShopify({
                                                mainSku: antecedentProductData.sku
                                            })
                                        }}
                                    >
                                        <i class="fas fa-trash"></i>&nbsp;Remove All From Shopify
                                    </button>
                                }
                            </div>
                        </div>

                        <div class="" id="upsellContainer">

                            <ListProductPage
                                collectionPageSku={
                                    filterPage === "all" ? [...collectionPageSku, ...productPageSku, ...cartPageSku, ...beforeCheckoutPageSku, ...CheckoutPageSku, ...postPurchasePageSku] :
                                        filterPage === "collection" ? collectionPageSku :
                                            filterPage === "product" ? productPageSku :
                                                filterPage === "cart" ? cartPageSku :
                                                    filterPage === "before_checkout" ? beforeCheckoutPageSku :
                                                        filterPage === "checkout" ? CheckoutPageSku :
                                                            filterPage === "post_purchase" ? postPurchasePageSku : ''
                                }
                                pushedToShopifySkus={
                                    filterPage === "all" ? [...pushedToShopifySkus?.post_purchase_page || [], ...pushedToShopifySkus?.collection_page || [], ...pushedToShopifySkus?.product_page || [], ...pushedToShopifySkus?.cart_page || [], ...pushedToShopifySkus?.before_checkout_page || [], ...pushedToShopifySkus?.checkout_page || [], ...pushedToShopifySkus?.post_purchase_page || []] :
                                        filterPage === "collection" ? pushedToShopifySkus?.collection_page :
                                            filterPage === "product" ? pushedToShopifySkus?.product_page :
                                                filterPage === "cart" ? pushedToShopifySkus?.cart_page :
                                                    filterPage === "before_checkout" ? pushedToShopifySkus?.before_checkout_page :
                                                        filterPage === "checkout" ? pushedToShopifySkus?.checkout_page :
                                                            filterPage === "post_purchase" ? pushedToShopifySkus?.post_purchase_page : ''
                                }
                                filterPage={filterPage}
                                view={view}
                                allSku={
                                    {
                                        collectionPageSku,
                                        CheckoutPageSku,
                                        cartPageSku,
                                        postPurchasePageSku,
                                        beforeCheckoutPageSku,
                                        productPageSku
                                    }
                                }
                                allPushedToShopifySku={
                                    {
                                        collection_page: pushedToShopifySkus?.collection_page,
                                        product_page: pushedToShopifySkus?.product_page,
                                        cart_page: pushedToShopifySkus?.cart_page,
                                        before_checkout_page: pushedToShopifySkus?.before_checkout_page,
                                        checkout_page: pushedToShopifySkus?.checkout_page,
                                        post_purchase_page: pushedToShopifySkus?.post_purchase_page,

                                    }
                                }
                                searchSku={searchSku}
                            />
                        </div>
                    </div>
                }


                {isOpen && (
                    <AssignmentLogsModal
                        onClose={() => setIsOpen(false)}
                        currentAnalysisData={currentAnalysisData}
                        order_details_id={order_details_id}
                        selectedSkuReport={selectedSkuReport}
                        antecedentProductData={antecedentProductData}
                    />
                )}

            </main>
        </div>
    )
}

export default ProductDesign;